var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_602_1391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.28023 0.842284C7.0107 0.912597 6.77339 1.10596 6.65034 1.35791L6.5771 1.50439L6.56831 5.23682L6.56245 8.97217L5.63081 8.04639C4.77827 7.19678 4.68745 7.11768 4.53218 7.05908C4.32417 6.98291 4.05171 6.97705 3.84956 7.04736C3.65327 7.11475 3.36909 7.39893 3.30171 7.59521C3.2314 7.79736 3.23726 8.06982 3.31343 8.27783C3.37202 8.43896 3.47163 8.54443 5.16792 10.2378C6.59175 11.6616 6.98726 12.0425 7.10445 12.0981C7.31245 12.1978 7.68745 12.1978 7.89546 12.0981C8.01265 12.0425 8.40816 11.6616 9.83198 10.2378C11.5488 8.521 11.6279 8.44189 11.6894 8.27197C11.7714 8.04346 11.7626 7.72119 11.666 7.5249C11.5839 7.35205 11.3964 7.16162 11.2236 7.07959C11.0244 6.97998 10.705 6.97119 10.4736 7.05908C10.3095 7.11768 10.2334 7.18506 9.36909 8.04639L8.43745 8.97217L8.43159 5.23682L8.42281 1.50439L8.3232 1.31982C8.1562 1.01221 7.90132 0.851073 7.56148 0.830565C7.45601 0.824706 7.33003 0.827636 7.28023 0.842284Z",
    fill: "#006D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.717688 13.9678C0.454016 14.0322 0.210852 14.2314 0.0878054 14.4834C-0.0118039 14.6855 -0.0147336 15.0635 0.0819461 15.2598C0.181555 15.4678 0.301673 15.5908 0.503821 15.7021L0.688391 15.8018H7.49991H14.3114L14.4609 15.7227C14.6835 15.6055 14.7743 15.5176 14.8857 15.3125C14.9765 15.1426 14.9853 15.1074 14.9853 14.8789C14.9853 14.6504 14.9765 14.6152 14.8857 14.4453C14.7773 14.2432 14.6542 14.126 14.4433 14.0234L14.3114 13.9561L7.55851 13.9502C3.84366 13.9502 0.767493 13.9561 0.717688 13.9678Z",
    fill: "#006D5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_602_1391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.816406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.6868184721cd3a807f1bd40a9dbb8722.svg";
export { ForwardRef as ReactComponent };